import React from 'react';

// Shared step-progress bar for multi-step wizards. Nothing in this
// codebase had a visual step indicator before this (ApprovalWizard.jsx
// is the closest existing "wizard" and has no progress UI either) --
// built generically so any future wizard can reuse it, not signup-only.
export default function WizardProgress({ steps, currentStep }) {
  return (
    <div className="flex items-start mb-8 w-full">
      {steps.map((label, i) => {
        const stepNum = i + 1;
        const isActive = stepNum === currentStep;
        const isDone = stepNum < currentStep;
        return (
          <React.Fragment key={label}>
            <div className="flex flex-col items-center flex-shrink min-w-0" style={{ maxWidth: '5.5rem' }}>
              <div
                className="w-6 h-6 sm:w-8 sm:h-8 rounded-full flex items-center justify-center font-bold text-xs sm:text-sm flex-shrink-0"
                style={
                  isDone
                    ? { backgroundColor: '#c9a961', color: '#0d2818' }
                    : isActive
                    ? { backgroundColor: 'transparent', color: '#c9a961', border: '2px solid #c9a961' }
                    : { backgroundColor: 'transparent', color: '#999999', border: '2px solid #3d5a4a' }
                }
              >
                {isDone ? '✓' : stepNum}
              </div>
              <span
                className="text-body-xs mt-1 text-center leading-tight break-words"
                style={{ color: isActive ? '#c9a961' : '#999999' }}
              >
                {label}
              </span>
            </div>
            {stepNum < steps.length && (
              <div
                className="flex-1 h-0.5 mx-1 sm:mx-2 flex-shrink min-w-[0.5rem] mt-3"
                style={{ backgroundColor: isDone ? '#c9a961' : '#3d5a4a' }}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
